<template>
  <div class="linebreak" :class="size"/>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "l",
    },
  },
}
</script>

<style lang="scss">
.linebreak {
  &.xl {}
  &.l { height: 70px; }
  &.m { height: 30px; }
  &.s {
    height: 20px;
    @media (max-width: 767px) {
      height: 5px;
    }
  }
  &.xs { height: 10px; }
}
</style>



// WEBPACK FOOTER //
// LineBreak.vue?200cb991